export default function makeEntity<T>(baseEntity: T) {
  return function (override?: Partial<T>): T {
    return { ...baseEntity, ...override };
  };
}
